import type { IconData } from '@stacksjs/iconify-core'

export const zoomIn: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M37.886 32.427A18.9 18.9 0 0 0 41 22c0-10.493-8.507-19-19-19S3 11.507 3 22s8.507 19 19 19c3.863 0 7.456-1.153 10.456-3.133l.977 1.177c1.261 1.522 2.504 3.022 3.868 4.503c1.61 1.747 4.06 1.952 5.76.293a47 47 0 0 0 .801-.801c1.66-1.701 1.454-4.151-.293-5.761c-1.48-1.365-2.98-2.608-4.502-3.87q-.588-.487-1.181-.981\"/><path d=\"M10 21.975a12 12 0 1 0 24 0a12 12 0 1 0-24 0M16 22h12m-6-6v12\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default zoomIn
